import React, { useEffect, useRef } from 'react';
export function Audit() {
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -50px 0px'
    });
    const reveals = sectionRef.current?.querySelectorAll('.reveal');
    reveals?.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  const auditItems = [{
    icon: '🌐',
    text: 'Análisis de tu web actual (o competencia)'
  }, {
    icon: '🎯',
    text: 'Oportunidades de conversión perdidas'
  }, {
    icon: '🔍',
    text: 'SEO local y posicionamiento Google'
  }, {
    icon: '📱',
    text: 'Experiencia móvil y velocidad'
  }, {
    icon: '🤖',
    text: 'Potencial de automatización con IA'
  }];
  return <div ref={sectionRef} className="bg-[var(--bg-2)] border-t border-b border-[var(--border)] py-12 md:py-20 px-6" id="auditoria" data-id="element-15">
      <div className="max-w-[1200px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-20 items-center" data-id="element-16">
        <div data-id="element-17">
          <div className="inline-flex items-center gap-2 bg-[linear-gradient(135deg,rgba(204,255,0,0.15)_0%,rgba(204,255,0,0.05)_100%)] border border-[rgba(204,255,0,0.3)] rounded-full px-3.5 py-1.5 text-xs font-extrabold text-[var(--neon)] tracking-[0.06em] uppercase mb-5 reveal" data-id="element-18">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" data-id="element-19">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" data-id="element-20" />
            </svg>
            100% Gratis · Sin trampa
          </div>
          <h2 className="font-black text-[clamp(32px,5vw,56px)] leading-[1.05] tracking-[-0.03em] mb-5 reveal delay-1" data-id="element-21">
            Análisis web
            <br data-id="element-22" />
            profesional
            <br data-id="element-23" />
            <span className="text-blue" data-id="element-24">totalmente gratis.</span>
          </h2>
          <p className="text-[17px] text-[var(--text-muted)] leading-[1.65] max-w-[560px] mb-6 md:mb-8 reveal delay-2" data-id="element-25">
            Analizamos tu web actual (o la de tu competencia si no tienes) y te
            mostramos exactamente qué necesitas para empezar a vender online.
          </p>
          <div className="reveal delay-3" data-id="element-26">
            <a href="#contacto" className="inline-flex items-center justify-center gap-2 font-extrabold text-base px-8 py-4 rounded-[20px] bg-[var(--neon)] text-black shadow-[0_0_0_1px_rgba(204,255,0,0.3),0_8px_24px_-4px_rgba(204,255,0,0.4),inset_0_1px_1px_rgba(255,255,255,0.4)] transition-all duration-[0.25s] hover:-translate-y-0.5 hover:shadow-[0_0_0_1px_rgba(204,255,0,0.5),0_16px_32px_-4px_rgba(204,255,0,0.5),inset_0_1px_1px_rgba(255,255,255,0.4)]" data-id="element-27">
              Quiero mi análisis GRATIS →
            </a>
          </div>
        </div>

        <div className="bg-[linear-gradient(135deg,#0A1628_0%,#050D1E_100%)] border border-[var(--border-blue)] rounded-[28px] p-10 relative overflow-hidden shadow-[0_0_0_1px_rgba(0,87,255,0.2),0_40px_80px_-20px_rgba(0,0,0,0.8),0_0_60px_rgba(0,87,255,0.05)] reveal delay-1" data-id="element-28">
          <div className="absolute -top-[100px] -right-[100px] w-[300px] h-[300px] bg-[radial-gradient(circle,rgba(0,87,255,0.15)_0%,transparent_70%)] pointer-events-none" data-id="element-29"></div>
          <div className="relative z-10" data-id="element-30">
            <h3 className="font-extrabold text-lg mb-2" data-id="element-31">Qué analizamos</h3>
            <p className="text-sm text-[var(--text-muted)] mb-1" data-id="element-32">
              Un diagnóstico completo de 5 puntos clave
            </p>
            <div className="flex flex-col gap-4 my-8" data-id="element-33">
              {auditItems.map((item, i) => <div key={i} className="flex items-center gap-3.5 py-3.5 px-4 bg-[var(--surface)] border border-[var(--border)] rounded-xl text-sm font-semibold transition-all duration-[0.25s] hover:border-[var(--border-blue)] hover:bg-[var(--blue-dim)] hover:translate-x-1.5" style={{
              transitionDelay: `${i * 0.05}s`
            }} data-id="element-34">
                  <div className="w-8 h-8 rounded-md bg-[var(--blue-dim)] border border-[var(--border-blue)] flex items-center justify-center flex-shrink-0 text-[15px]" aria-hidden="true" data-id="element-35">
                    {item.icon}
                  </div>
                  {item.text}
                </div>)}
            </div>
            <a href="#contacto" className="inline-flex items-center justify-center gap-2 font-bold text-sm px-5 py-2.5 rounded-xl bg-[linear-gradient(180deg,#0066FF_0%,#0047D4_100%)] text-white shadow-[0_0_0_1px_rgba(0,87,255,0.4),0_8px_24px_-4px_rgba(0,87,255,0.5),inset_0_1px_1px_rgba(255,255,255,0.2)] transition-all duration-[0.25s] hover:-translate-y-0.5 hover:shadow-[0_0_0_1px_rgba(0,87,255,0.6),0_16px_32px_-4px_rgba(0,87,255,0.6)] w-full justify-center" data-id="element-36">
              Obtener análisis ahora →
            </a>
          </div>
        </div>
      </div>
    </div>;
}